export default __webpack_public_path__ + "static/media/first-visit-checklist.3f8db1ed.png";